var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagActive = function SvgBagActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M20 0c6.075 0 11 4.925 11 11v1h9v44H0V12h9v-1C9 4.925 13.925 0 20 0m-9 14H9v6h2zm20 0h-2v6h2zM20 2a9 9 0 0 0-9 9v1h18v-1a9 9 0 0 0-9-9"
  })));
};
export default SvgBagActive;